import React, { useEffect, useState } from 'react'
import KeyboardIcon from '@mui/icons-material/Keyboard';
import TextField from '@mui/material/TextField';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { btoa , toUnicode } from '../../../cryptographic/crypto';

import { useForm, Controller } from "react-hook-form";

function FromContent({ btnTypeG, setbtnTypeG, socket, message, sendMessage, hideIframe, indexLength, arrayLength }) {
    const { register, handleSubmit, setValue, formState: { errors }, reset, control } = useForm();
    const [show, setShow] = useState(false)
    const [formData, setFormData] = useState(message?.buttons.find((btn) => btn.mode === "bottom")?.form)
    const closeIframe = () => {
        setShow(false)
    }
    const [btnType, setbtnType] = useState("footer")
    const [showBtn, setShowBtn] = useState(true)
    useEffect(() => {
        setShow(false)
    }, [hideIframe])

    useEffect(() => {
        // console.log(arrayLength +"Arraylength  - " + indexLength+ "IndexLength")
        setShow(false)
        if (parseInt(arrayLength?.length - 1) > indexLength) {
            setShowBtn(false)
            setShow(false)
        }
    }, [arrayLength])

    const [category, setCategory] = useState('');
    const onSubmitHandler = (data) => {
        // console.log(data, "formData")
        // console.log(formData, "formData2")
        setShow(false)
        setShowBtn(false)
        setbtnType("chat")
        setbtnTypeG("chat")
        // console.error(data, "form_data")
        const emitData = message?.buttons.find((btn) => btn.mode === "bottom")
        let sendData = {
            text : `<div><div>Ticket Details:-</div><div><strong>Subject:-</strong> ${data?.subject}</div><div><strong>Description:-</strong> ${data?.message}</div></div>`,
            payload: toUnicode(emitData.payload),
            info:JSON.stringify(data)
            //notification : 'N'
        }
        socket.emit(btoa(["user-send",sendData]));
    };
    
    // const SendFormData =()=>{
    //     let sendData = {
    //         text : toUnicode(e.title),
    //         payload: toUnicode(e.payload),
    //         info:JSON.stringify({key:value,})
    //         //notification : 'N'
    //     }
    //     socket.emit(btoa(["user-send",sendData]));
    // }

    // console.log(errors, "errors form")
    return (
        <>
            {
                showBtn ?
                    <>
                        {
                            btnTypeG === "chat" ?
                                message?.buttons?.map((btns) => {
                                    return (
                                        btns?.mode === "bottom" ?
                                            <button type="button" className="btn-outline mb-8" onClick={() => { setShow(true) }}>{btns?.title}</button>
                                            :
                                            <button type="button" className="btn-outline mb-8" onClick={() => { setShowBtn(false); sendMessage(btns) }}>{btns?.title}</button>
                                    )
                                })
                                :
                                <>
                                    {
                                        btnType === "footer" ?
                                            <div className="appointment-footer-wrapper">
                                                <KeyboardIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat") }} />
                                                {
                                                    message?.buttons?.map((btns) => {
                                                        return (
                                                            btns?.mode === "bottom" ?
                                                                <button type="button" className="btn-default btn-seprate" onClick={() => { setShow(true) }}>{btns?.title}</button>
                                                                :
                                                                <button type="button" className="btn-default btn-seprate" onClick={() => { setShowBtn(false); sendMessage(btns) }}>{btns?.title}</button>
                                                        )
                                                    })
                                                }
                                            </div>
                                            :
                                            message?.buttons?.map((btns) => {
                                                return (
                                                    btns?.mode === "bottom" ?
                                                        <button type="button" className="btn-outline mb-8" onClick={() => { setShow(true) }}>{btns?.title}</button>
                                                        :
                                                        <button type="button" className="btn-outline mb-8" onClick={() => { setShowBtn(false); sendMessage(btns) }}>{btns?.title}</button>
                                                )
                                            })
                                    }
                                </>
                        }
                    </>
                    :
                    message?.buttons?.map((btns) => {
                        return (
                            <button type="button" className="btn-outline mb-8 btn-disabled" disabled onClick={() => { setShowBtn(false) }}>{btns?.title}</button>
                        )
                    })
            }
            <div className={`edit-form-wrapper ${show ? "show-edit-form" : ""}`}>
                {
                    message?.buttons?.map((btns) => {
                        return (
                            (btns?.mode === "bottom" && btns?.type === "form") ?
                                <>
                                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                                        <div className='edit-header'>
                                            <KeyboardBackspaceIcon onClick={() => setShow(false)} />
                                            <h4>Edit</h4>
                                            <div>&nbsp;&nbsp;&nbsp;</div>
                                        </div>
                                        <div className='edit-form-body'>
                                            {
                                                btns?.form.map((form, i) => {
                                                    setValue(form?.key, form?.value)
                                                    return (
                                                        form.type === "select" ?
                                                            <div className='form-group' key={i}>
                                                                <Controller
                                                                    name={form?.key}
                                                                    control={control}
                                                                    {...register(form?.key, {
                                                                        required: true
                                                                    })}
                                                                    render={({
                                                                        field: { onChange, onBlur, value, name, ref }
                                                                    }) => (
                                                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} >
                                                                            <InputLabel id={"demo-simple-select-standard-label" + i}>{form?.title}</InputLabel>
                                                                            <Select
                                                                                labelId={"demo-simple-select-standard-label" + i}
                                                                                id={"demo-simple-select-standard-label" + i}
                                                                                defaultValue={value}
                                                                                onChange={(e) => {
                                                                                    onChange(e.target.value);
                                                                                    setCategory(e.target.value);
                                                                                    let cloneData = [...formData];
                                                                                    cloneData[i].value = e.target.value;
                                                                                    setFormData(cloneData);
                                                                                }}
                                                                                label={form?.title}
                                                                                inputRef={ref}
                                                                            >
                                                                                {
                                                                                    form?.data?.map((menu) => {
                                                                                        return (
                                                                                            <MenuItem value={menu?.value}>{menu?.title}</MenuItem>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </FormControl>
                                                                    )}
                                                                />
                                                                {errors[form?.key] && errors[form?.key].type === "required" && <p className="error">{form?.title} is required</p>}
                                                            </div>
                                                            :
                                                            form.type === "phone" ?
                                                                <div className='form-group' key={i}>
                                                                    <Controller
                                                                        control={control}
                                                                        {
                                                                        ...register(form?.key, {
                                                                            required: {
                                                                                value: true,
                                                                                message: `${form?.title} is required`
                                                                            },
                                                                            minLength: {
                                                                                value: form?.other_info?.min_lenghth,
                                                                                message: `Minimum ${form?.other_info?.min_lenghth} characters required`
                                                                            },
                                                                            maxLength: {
                                                                                value: form?.other_info?.max_length,
                                                                                message: `Maximum ${form?.other_info?.max_length} characters required`
                                                                            },
                                                                            pattern: {
                                                                                value: /^-?\d*\.?\d*$/,
                                                                                message: `Enter valid ${form?.title}` // JS only: <p>error message</p> TS only support string
                                                                            }
                                                                        })
                                                                        }
                                                                        render={({
                                                                            field: { onChange, onBlur, value, name, ref }
                                                                        }) => (
                                                                            <TextField
                                                                                id={"standard-multiline-flexible" + i}
                                                                                label={form?.title}
                                                                                variant="standard"
                                                                                defaultValue={form?.value}
                                                                                inputRef={ref}
                                                                                onChange={(event) => {
                                                                                    onChange(event.target.value);
                                                                                    let cloneData = [...formData];
                                                                                    cloneData[i].value = event.target.value;
                                                                                    setFormData(cloneData);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                    {errors[form?.key] && <p className="error">{errors[form?.key]?.message}</p>}
                                                                </div>
                                                                :
                                                                form.type === "email" ?
                                                                    <div className='form-group' key={i}>
                                                                        <Controller
                                                                            control={control}
                                                                            {
                                                                            ...register(form?.key, {
                                                                                required: {
                                                                                    value: true,
                                                                                    message: `${form?.title} is required`
                                                                                },
                                                                                minLength: {
                                                                                    value: form?.other_info?.min_lenghth,
                                                                                    message: `Minimum ${form?.other_info?.min_lenghth} characters required`
                                                                                },
                                                                                maxLength: {
                                                                                    value: form?.other_info?.max_length,
                                                                                    message: `Maximum ${form?.other_info?.max_length} characters required`
                                                                                },
                                                                                pattern: {
                                                                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                                                    message: `Enter valid ${form?.title}` // JS only: <p>error message</p> TS only support string
                                                                                }
                                                                            })
                                                                            }
                                                                            render={({
                                                                                field: { onChange, onBlur, value, name, ref }
                                                                            }) => (
                                                                                <TextField
                                                                                    id={"standard-multiline-flexible" + i}
                                                                                    label={form?.title}
                                                                                    variant="standard"
                                                                                    defaultValue={form?.value}
                                                                                    inputRef={ref}
                                                                                    onChange={(event) => {
                                                                                        onChange(event.target.value);
                                                                                        let cloneData = [...formData];
                                                                                        cloneData[i].value = event.target.value;
                                                                                        setFormData(cloneData);
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                        {errors[form?.key] && <p className="error">{errors[form?.key]?.message}</p>}
                                                                    </div>
                                                                :
                                                                    <div className='form-group' key={i}>
                                                                        <Controller
                                                                            // name={form?.key}
                                                                            control={control}
                                                                            {
                                                                            ...register(form?.key, {
                                                                                required: {
                                                                                    value: true,
                                                                                    message: `${form?.title} is required`
                                                                                },
                                                                                minLength: {
                                                                                    value: form?.other_info?.min_lenghth,
                                                                                    message: `Minimum ${form?.other_info?.min_lenghth} characters required`
                                                                                },
                                                                                maxLength: {
                                                                                    value: form?.other_info?.max_length,
                                                                                    message: `Maximum ${form?.other_info?.max_length} characters required`
                                                                                }
                                                                            })
                                                                            }

                                                                            render={({
                                                                                field: { onChange, onBlur, value, name, ref }
                                                                            }) => (
                                                                                <TextField
                                                                                    id={"standard-multiline-flexible" + i}
                                                                                    label={form?.title}
                                                                                    variant="standard"
                                                                                    defaultValue={form?.value}
                                                                                    inputRef={ref}
                                                                                    multiline={form.type === "textarea" ? true : false}
                                                                                    onChange={(event) => {
                                                                                        onChange(event.target.value);
                                                                                        let cloneData = [...formData];
                                                                                        cloneData[i].value = event.target.value;
                                                                                        setFormData(cloneData);
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                        {errors[form?.key] && <p className="error">{errors[form?.key]?.message}</p>}
                                                                    </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className='edit-footer'>
                                            <button type="submit" className="btn-default mb-8">Update</button>
                                        </div>
                                    </form>
                                </>
                                :
                                <></>
                        )
                    })
                }
            </div>
        </>
    )
}
export default FromContent
